import React from "react";
import { FaReact } from "react-icons/fa";
import { AiOutlineDollar, AiOutlineNumber, AiOutlinePercentage } from "react-icons/ai";
import { GrDocumentMissing } from "react-icons/gr";
import { HiOutlineDocumentDownload } from "react-icons/hi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReportCard from "../Components/ReportCard";
import ExportManifestPopup from "../Components/ManifestPopupCard";
import ExportMissingItemsPopup from "../Components/MissingItemsExportPopupCard";
import { useLoading } from "../utils/loading/LoadingContext";
import "./styles/modern-pages.css";
import "./styles/reports.css";

export default function Reports() {
  const { setLoading } = useLoading();

  const formatDate = (date) => {
    const adjustedDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );
    return adjustedDate.toISOString().split("T")[0];
  };

  const exportMissingItems = async (startDate, endDate) => {
    const start = formatDate(startDate);
    const end = formatDate(endDate);
    const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
    setLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/api/export-missing-items/?start_date=${start}&end_date=${end}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );

      if (!response.ok) {
        toast.error("Failed to export missing items.");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `missing_${start}_to_${end}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error exporting missing items:", error);
      toast.error("Failed to export missing items.");
    } finally {
      setLoading(false);
    }
  };

  const reportCards = [
    {
      icon: HiOutlineDocumentDownload,
      iconColor: "#2563eb",
      iconBgColor: "#eaf1ff",
      title: "Export Manifest",
      description: "Prepare a CSV export in the background and download it when ready.",
      popupContent: <ExportManifestPopup />,
    },
    // {
    //   icon: GrDocumentMissing,
    //   iconColor: "#b42318",
    //   iconBgColor: "#fef3f2",
    //   title: "Missing Items",
    //   description: "Select a date range and download missing inventory items as a spreadsheet.",
    //   popupContent: <ExportMissingItemsPopup onExport={exportMissingItems} />,
    // },
    // {
    //   icon: AiOutlinePercentage,
    //   iconColor: "#7c3aed",
    //   iconBgColor: "#f3e8ff",
    //   title: "Recovery Rate",
    //   description: "Generate recovery-rate reports from selected inventory properties.",
    // },
    // {
    //   icon: AiOutlineNumber,
    //   iconColor: "#059669",
    //   iconBgColor: "#e7f8ef",
    //   title: "Quantity",
    //   description: "Generate unit and quantity reports from selected properties.",
    // },
    // {
    //   icon: AiOutlineDollar,
    //   iconColor: "#b54708",
    //   iconBgColor: "#fffaeb",
    //   title: "Price Dispute",
    //   description: "Review inventory properties and generate a pricing dispute report.",
    //   viewType: "page",
    //   viewMorePath: "/price-dispute",
    // },
    // {
    //   icon: FaReact,
    //   iconColor: "#0891b2",
    //   iconBgColor: "#e6f7fb",
    //   title: "Generate Search Result",
    //   description: "Generate a report from inventory search results and filters.",
    // },
  ];

  return (
    <div className="modern-page reports-body">
      <div className="modern-page-shell">
        <header className="modern-page-header">
          <h1 className="modern-page-title">Reports</h1>
        </header>

        <div className="reports-grid">
          {reportCards.map((report) => (
            <ReportCard
              key={report.title}
              {...report}
              viewType={report.viewType || "popup"}
            />
          ))}
        </div>
        <ToastContainer />
      </div>
    </div>
  );
}
